"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _compareVersion = _interopRequireDefault(require("./compareVersion"));

var _importScript = _interopRequireDefault(require("./importScript"));

var _pureUA = _interopRequireDefault(require("./pureUA"));

var _randString = _interopRequireDefault(require("./randString"));

var reqwest = require('reqwest');

var assign = require('object-assign');

/**
 * 微信二次分享
 * @param  {Object} shareContent 分享参数对象
 * @shareContent {String} shareContent.title 分享标题
 * @shareContent {String} shareContent.desc 分享描述
 * @shareContent {String} shareContent.link 分享链接 默认为当前页面地址
 * @shareContent {String} shareContent.imgUrl 分享卡片封面图地址
 * @param  {Boolean} options.debug 是否启用调试
 * @param  {String} options.appId 微信公众号对应的唯一标识
 */
function wechatShare() {
  var shareContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var shareConfig = arguments.length > 1 ? arguments[1] : undefined;
  var debug = shareConfig.debug,
      _shareConfig$appId = shareConfig.appId,
      appId = _shareConfig$appId === void 0 ? 'wxb9dfe7ce6f273103' : _shareConfig$appId,
      _shareConfig$menuList = shareConfig.menuList,
      menuList = _shareConfig$menuList === void 0 ? [] : _shareConfig$menuList;
  var nonceStr = (0, _randString["default"])(14);
  var timestamp = ~~((0, _now["default"])() / 1000);
  shareContent.link = shareContent.link || window.location.href; // 原有的 wx.onMenuShareTimeline、wx.onMenuShareAppMessage、wx.onMenuShareQQ、wx.onMenuShareQZone 接口，即将废弃。
  // 请尽快迁移使用客户端6.7.2及JSSDK 1.4.0以上版本支持的 wx.updateAppMessageShareData、updateTimelineShareData 接口。
  // from https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115

  var UA = (0, _pureUA["default"])(navigator.userAgent);
  var isOldVersion = UA.browser.weixin && (0, _compareVersion["default"])(UA.browser.version, '6.7.2') < 0;
  var SDKUrl = shareConfig.SDKUrl;

  if (shareConfig.SDKUrl140 && !isOldVersion) {
    SDKUrl = shareConfig.SDKUrl140;
  }

  (0, _importScript["default"])(SDKUrl, {
    callback: function callback() {
      reqwest({
        data: {
          appid: appId,
          noncestr: nonceStr,
          timestamp: timestamp,
          url: window.location.href
        },
        type: 'jsonp',
        url: shareConfig.signatureAPI
      }).then(function (res) {
        if (res.code === 1) {
          window.wx.config({
            appId: appId,
            debug: debug,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems'].concat((0, _toConsumableArray2["default"])(isOldVersion ? [] : ['updateAppMessageShareData', 'updateTimelineShareData'])),
            nonceStr: nonceStr,
            signature: res.signature,
            timestamp: timestamp
          });
        }

        var wx = window.wx;
        wx.ready(function () {
          if (menuList.length) {
            window.wx.hideMenuItems({
              menuList: menuList
            });
          }

          if (!isOldVersion && wx.updateAppMessageShareData) {
            wx.updateAppMessageShareData(shareContent);
          } else {
            wx.onMenuShareAppMessage(shareContent);
          }

          var shareTimelineContent = assign({}, shareContent);

          if (!isOldVersion && wx.updateTimelineShareData) {
            wx.updateTimelineShareData(shareTimelineContent);
          } else {
            wx.onMenuShareTimeline(shareTimelineContent);
          }
        });
        wx.error(function (res) {
          // tslint:disable-next-line no-console
          console.error(res);
        });
      })["catch"](function (error) {
        // tslint:disable-next-line no-console
        console.log(error);
      });
    }
  });
}

wechatShare["default"] = wechatShare;
var _default = wechatShare;
exports["default"] = _default;
module.exports = exports["default"];